import { CircleAlert } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import { dispatchHandler } from '../../../../../helper/apiHelperFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { getPermissionKey } from '../../../../../helper/permissions';
import NotificationCompleteTableSkeleton from '../../../../administration/globalConfiguration/configComponent/notifications/NotificationCompleteTableSkeleton';
import GenericInput from '../../../../../genericComponents/input/GenericInputComponent';
import Icons from '../../../../../assets/icons';
import NotificationMatrix from '../../../../administration/globalConfiguration/configComponent/notifications/NotificationMatrix';
import LanguageTranslator from '../../../../../locals/LanguageTranslator';

const UserNotifications = () => {

    const [modulesData, setModulesData] = useState([]);

    const [filterConfig, setFilterConfig] = useState({});

    const [currentSearch, setCurrentSearch] = useState("");

    const dispatch = useDispatch()

    const getTableDocumentFormatData = useSelector(state => state?.administrationStore?.getTableDocumentFormatData)

    useEffect(() => {
        if (getTableDocumentFormatData?.isSuccess) {
            let data = getTableDocumentFormatData?.data?.resource || [];
            if (data) {
                setModulesData(data);
            }
        }
    }, [getTableDocumentFormatData?.isSuccess])

    useEffect(() => {
        // get the modules data
        setModulesData([]);
        dispatchHandler(dispatch, "getTableDocumentFormatRequest", {
            type: "tenant_notification_config"
        }, getPermissionKey("common", "commonfunctionality", "view"))
    }, [])

    if (getTableDocumentFormatData?.isLoading) {
        // If the modal api is loading then show the tableskeleton
        return <NotificationCompleteTableSkeleton />
    }

    let labelObj = {
        "module": "Module"
    }

    const renderTable = () => {
        return <NotificationMatrix
            filterConfig={filterConfig}
            currentSearch={currentSearch}
            level = "user"
            setCurrentSearch={setCurrentSearch}
        />
    }

    return (
        <div className='user-notifications overflow-hidden gcn-top h-full flex flex-col py-2.5 px-5'>
            <h3 className='mb-0 text-lg font-bold text-[#21314b]'>Notification Matrix</h3>
            <div className='my-[10px] px-3 pr-6 py-2 text-xs bg-[#FFEECC] flex items-center gap-2.5'>
                <div><CircleAlert color='#B65700' strokeWidth={1.75} size={20} /></div>
                <LanguageTranslator tag='p' className='mb-0 text-[#B65700]'>The Notification Matrix allows users to manage and customize their notification preferences effortlessly. This feature provides a clear overview of all available notification types and their respective delivery channels (e.g., email, whatsapp, WeChat, Desktop Notifications, App notifications).</LanguageTranslator>
            </div>

            <div className='gcnt-inputs flex items-end gap-4'>
                <div className='flex items-center'>
                    {/* module and submodule filter inputs */}
                    {["module"]?.map(key => (
                        <GenericInput
                            type="dropdown"
                            label={() => <label className='gib-label-heading'><div className={`gibl-label ${key == "subModule" && !filterConfig?.["module"] && 'disabled-label'}`} >{`${labelObj?.[key] || ""} :`}</div></label>}
                            value={filterConfig?.[key]?.["name"] || ""}
                            onChange={(val) => {
                                let updatedFilterConfig = { ...filterConfig };
                                updatedFilterConfig[key] = val;
                                setFilterConfig(updatedFilterConfig);
                            }}
                            iconRight={<Icons.DownArrowNew />}
                            inputProps={() => ({
                                headerKeys: {
                                    "name": {}
                                },
                                itemKeys: { name: ["name"] },
                                getListData: () => {
                                    switch (key) {
                                        case "module": return modulesData || [];
                                    }
                                }
                            })}
                            placeholder='Select a Module'
                        />
                    ))}
                </div>
                <div className='gcnti-right'>
                    {/* The search input to search inside the table */}
                    <GenericInput
                        inputKey="search"
                        dependentFieldsObject={["search"]}
                        type="text"
                        placeholder="Search Events"
                        iconLeft={<Icons.GlobalSearchIcon />}
                        value={currentSearch}
                        onChange={(text) => setCurrentSearch(text?.target?.value || "")}
                    />
                </div>
            </div>
            <div className='gc-notifications relative !p-[0] !h-[calc(100%-90px)]'>

                {renderTable()}
            </div>
        </div>
    )
}

export default UserNotifications
